import { render, staticRenderFns } from "./VaButton.vue?vue&type=template&id=394a9dcc&scoped=true&"
import script from "./VaButton.vue?vue&type=script&lang=ts&"
export * from "./VaButton.vue?vue&type=script&lang=ts&"
import style0 from "./VaButton.vue?vue&type=style&index=0&id=394a9dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a9dcc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394a9dcc')) {
      api.createRecord('394a9dcc', component.options)
    } else {
      api.reload('394a9dcc', component.options)
    }
    module.hot.accept("./VaButton.vue?vue&type=template&id=394a9dcc&scoped=true&", function () {
      api.rerender('394a9dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaButton.vue"
export default component.exports